import { Helpers } from '@grandvisionhq/inventory';

/**
 *
 * When a user completely fills in a prescription column, the matching product is added to both
 * `selectedLensVariants` and `priceTotals.selectedProducts`
 *
 * If the user then disables the checkbox for a column, that product is removed from `priceTotals.selectedProducts`
 *
 * So, in order to verify if the user has configired an non-orderable product to be added to cart,
 * we need to check `priceTotals.selectedProducts` to see if the column is enabled,
 * and then check `selectedLensVariants` to see if the product is in stock.
 * If it is not in stock, and allowBackOrder is not true, then the product is non-orderable.
 *
 *
 * This function returns `true` if any enabled product is non-orderable.
 */ const hasNonOrderableProduct = ({ selectedLensVariants , priceTotals  })=>{
    const { selectedProducts  } = priceTotals;
    return selectedProducts.some(({ sku  })=>{
        const configuredVariant = selectedLensVariants.find((variant)=>{
            return (variant === null || variant === void 0 ? void 0 : variant.sku) === sku;
        });
        const availableQuantity = Helpers.getAvailableQuantity(configuredVariant === null || configuredVariant === void 0 ? void 0 : configuredVariant.availability);
        return availableQuantity === 0 && (configuredVariant === null || configuredVariant === void 0 ? void 0 : configuredVariant.attributes.allowBackOrder) !== true;
    });
};

export { hasNonOrderableProduct };
//# sourceMappingURL=has-non-orderable-product.js.map
